import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import spendingService from "_api/spendingService";
import utils from "utils";

const initialState = {
  selectedPage: 1,
  itemsTotal: 0,
  list: [],
  loading: false,
  error: null,
};

export const fetchSpending = createAsyncThunk(
  'spending/fetchSpending',
  async pageId => {
    const response = await spendingService.fetchSpending(pageId);
    return {selectedPage: pageId, ...response.data};
  }
);

const spendingSlice = createSlice({
  name: 'spending',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchSpending.pending, state => {
      state.list = [];
      //state.itemsTotal = 0;
      state.loading = true;
      state.error = null;
    })
    builder.addCase(fetchSpending.fulfilled, (state, action) => {
      state.list = action.payload.periods;
      state.itemsTotal = action.payload.total;
      state.selectedPage = utils.getSelectedPage(action.payload.selectedPage, action.payload.total);
      state.loading = false;
    });
    builder.addCase(fetchSpending.rejected, (state, action) => {
      state.list = [];
      state.loading = false;
      state.itemsTotal = 0;
      state.selectedPage = 1;
      state.error = action.error;
    });
  }
});

export default spendingSlice.reducer;